import { RequestActionType } from '@strata/react-chat';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';

import { RequestSummarySection } from 'components/requests/dialogs/RequestSummarySection';
import { ResolveReasonInputs } from 'components/requests/dialogs/ResolveReasonInputs';
import { type PayerRequestActionDialogProps } from 'services/interfaces';
import { usePostRequestActivityMutation } from 'store/api/payerRequestApi';

const Title = 'Resolve and Monitor Request';

export const ResolveRequestDialog = ({
    onClose,
    payerId,
    requestDetails,
}: PayerRequestActionDialogProps) => {
    const [postRequestActivity] = usePostRequestActivityMutation();
    return (
        <Formik
            initialValues={{ ...ResolveReasonInputs.InitialValues }}
            enableReinitialize
            validateOnMount
            validationSchema={ResolveReasonInputs.ValidationSchema}
            onSubmit={async (values, { resetForm }) => {
                await postRequestActivity({
                    payerId,
                    requestId: requestDetails.requestId,
                    actionType: RequestActionType.RESOLVED,
                    ...ResolveReasonInputs.submitValues(values),
                }).unwrap();

                SuccessToast({ message: 'Request resolved succesfully. Monitoring in progress.' });
                resetForm();
                onClose();
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={`Confirm ${Title}`}
                    width={600}
                    isOpen
                    secondaryButtonLabel="No, Return To Request Details"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel={`Yes, ${Title}`}
                    isPrimaryButtonDisabled={
                        !(formik.isValid && formik.dirty) || formik.isSubmitting
                    }
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                Are you sure you want to resolve this request?
                            </div>
                            <RequestSummarySection requestDetails={requestDetails} />
                            <ResolveReasonInputs />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

ResolveRequestDialog.Title = Title;
